import { Component, OnInit , Input, Output, EventEmitter } from '@angular/core';

import { IonicPage, NavController, NavParams, AlertController, LoadingController, ModalController, ViewController } from 'ionic-angular';
import { Observable } from 'rxjs/Observable';
import { cuadreCajaDiarioValoresPorDenominacion } from '../../models/cuadreCajaDiarioValoresPorDenominacion'
import { Storage } from '@ionic/storage'
import { ClientesProvider } from '../../providers/clientes/clientes'
import { DenominacionesProvider } from '../../providers/denominaciones/denominaciones'
import { CuadreCajaDiarioValoresPorDenominacionProvider } from '../../providers/cuadre-caja-diario-valores-por-denominacion/cuadre-caja-diario-valores-por-denominacion'
import { ProveedoresCargarStockProvider } from '../../providers/proveedores-cargar-stock/proveedores-cargar-stock'
import { CajaProvider } from '../../providers/caja/caja'
import { ElectronService } from 'ngx-electron';
import { MODO_DESCONECTADO,NUBE_AWS,RUTA_MODO_DESCONECTADO, URL_SERVICIOS_LOCALES } from "../../config/url.servicio"
import { CompaniasProvider } from '../../providers/companias/companias'
import { UtilsProvider } from '../../providers/utils/utils'
import { PushProvider } from '../../providers/push/push';
import { Http,RequestOptions,Headers } from '@angular/http';
import { ImpresoraBluePage } from '../impresora-blue/impresora-blue';
import { AuthService } from '../../providers/auth-service';
import { InformesProvider } from '../../providers/informes/informes';

@IonicPage()
@Component({
  selector: 'page-cuadre-caja-diario-domicilios',
  templateUrl: 'cuadre-caja-diario-domicilios.html',
  providers:[AuthService]
})
export class CuadreCajaDiarioDomiciliosPage {

  public valorTotalReal = 0
  listaDenominaciones: any = []
  listaCorreos: any = []
  listaDenominacionesSend: any = []
  listaDenominacionesGrid: any = []
  public proveedorId:any
  public usuarioId:any
  public companiasId:any
  CuadreCajaDiarioValoresPorDenominacion:cuadreCajaDiarioValoresPorDenominacion[] = []
  public productosId:any
  public arrayWhere : any = [{"":""}];
  @Input() arrayWherelocal : any = []
  jsoncolumnanuevo = [];
  datosWhere: any = [];
  valorWhere: any = [];
  nuevacondicion: any = [];
  ValoresWhereConsultaarray = [];
  WhereCampo:Array<Object> = [];
  WhereCondicion:Array<Object> = [];
  WhereValor:Array<Object> = [];
  WhereCondicionFinal:Array<Object> = [];
  consultar: string = "";
  loader
  consultaagregadoArray: Array<Object> = [];
  valorIngresos: any = 0
  valorIngresosTodo:any = []

  valorIngresoDiscriminado:any = []

  valorIngresosTodoUsuario:any = []
  valorEgresos:any = 0
  seguimientoIngresosStock:any = [];
  seguimientoIngresosStockConect:any = [];
  valorReal:any=0
  correo:any=""
  from:any =""
  fechaCerrar:""
  posicion:number
  imprimirCierre:boolean = true
  manejaImpresoPorDefecto:boolean = true
  bluetooth:boolean = false
  token:string
  valorPagado:number = 0
  valorPendiente:number = 0
  valorBaseString: string = '0'
  base:number = 0
  valorEgreso:number = 0
  valorIngreso:number = 0
  valorPropinas:number= 0
  visualizarVentas = []
  totalVentas: number = 0;
  constructor(public navCtrl: NavController, public navParams: NavParams,
              public servicioDenominaciones: DenominacionesProvider,
              public servicioCuadres:CuadreCajaDiarioValoresPorDenominacionProvider,
              private storage:Storage,
              public utilidades:ClientesProvider,
              public denominacionesProviders:DenominacionesProvider,
              public alertControllers: AlertController,
              public loaders:LoadingController,
              public servicioStock:ProveedoresCargarStockProvider,
              public servicio: CajaProvider,
              private _electronService: ElectronService,
              public servicioCompania:CompaniasProvider,
              public utils:UtilsProvider,
              public push:PushProvider,
              public http: Http,
              public modalControllers: ModalController,
              public viewControllers:ViewController,
              public auth: AuthService,
            public servicioDescargar: InformesProvider) {
            this.storage.get('token').then((val) => {
                this.token = val
            });
            if(MODO_DESCONECTADO){
              console.log('entro en modo desconectado....')
              this.nuevacondicion.push({"":""})
              this.valorReal = 0
              this.valorTotalReal = 0
              this.valorIngresos = 0
              this.valorEgresos = 0
              this.elect()
            }else{
              this.servicioCompania.devolverVarios(['nombreCompania','nombreCargo','companiasId'])
              .then((val)=>{

                if(val){
                  this.from = val['nombreCompania']
                  let companiasId = val['companiasId']
                  this.push.buscarParametrosGenerales(companiasId).subscribe((data)=>{
                    if(NUBE_AWS) {
                      this.bluetooth = JSON.parse(data['_body']).data[0][0].bluetooth === 'B' ? true : false
                      this.imprimirCierre = JSON.parse(data['_body']).data[0][0].imprimirCierre === 'S' ? true : false
                      this.manejaImpresoPorDefecto = JSON.parse(data['_body']).data[0][0].manejaImpresoPorDefecto == 0 ? false : true
                    } else {
                      this.bluetooth = data[0][0].bluetooth === 'B' ? true : false
                      this.imprimirCierre = data[0][0].imprimirCierre === 'S' ? true : false
                      this.manejaImpresoPorDefecto = data[0][0].manejaImpresoPorDefecto == 0 ? false : true
                    }

                    if(this.manejaImpresoPorDefecto){
                        if(this.bluetooth){
                            this.manejaImpresoPorDefecto = false
                        }
                    }

                    },(error)=>{
                        console.log(error)
                    })


                }
              })
              this.buscarDenominaciones()
              this.nuevacondicion.push({"":""})
              this.buscarUsuario()
              this.buscarGridProveedores()
              this.buscarVentasDiarias()
              this.buscarcompanias()
              this.buscarCorreos()
            }

 }

    elect(){

    let resultado

    resultado = this._electronService.ipcRenderer.sendSync('buscarcompania-informacion-mododesconectado',RUTA_MODO_DESCONECTADO)

    let res = JSON.parse(resultado)
        for (let index = 0; index < res.length; index++) {
          const nombre = res[index]['nombreCompania']
          const companiaId = res[index]['companiasId']
          this.companiasId = companiaId
        }
      let denominaciones = this._electronService.ipcRenderer.sendSync('buscar-informacion-mododesconectado-denominaciones',RUTA_MODO_DESCONECTADO)
      if(!denominaciones){
          this.listaDenominaciones =JSON.parse(denominaciones)
        }else {
            this.listaDenominaciones =JSON.parse(denominaciones)
        }

        this.storage.get('usuariosIdDesconect').then((val)=>{
          if(val){
            this.usuarioId = val
          }else{
            this.usuarioId = 1
          }
        })


        let seguimientoIngresosStockConects = this._electronService.ipcRenderer.sendSync('buscar-seguimientoIngresosStock-modo-conectado',RUTA_MODO_DESCONECTADO)

        if(seguimientoIngresosStockConects.length ===0){
        }else {


            this.seguimientoIngresosStockConect =seguimientoIngresosStockConects
            for(var k=0;k<this.seguimientoIngresosStockConect.length;k++){

              var valor = this.seguimientoIngresosStockConect[k].nombre
              var json = JSON.parse(valor)
              for(var j=0;j<json.length;j++){

                this.valorEgresos +=json[j].Valor
                this.buscarValorReal()
              }
            }

         }
        let ventaDiaria  = this._electronService.ipcRenderer.sendSync('buscar-totalventasDiarias-mododesconectado',RUTA_MODO_DESCONECTADO)

        if(ventaDiaria.length>0){
          var data = JSON.parse(ventaDiaria)
          this.valorIngresos += data[0].ventaDiaria - (this.valorPendiente > 0 ? this.valorPendiente : 0)

        }

        let resultVenta  = this._electronService.ipcRenderer.sendSync('buscar-ventas-modo-desconectado-totales',RUTA_MODO_DESCONECTADO)

        if(resultVenta){
          this.valorReal = 0
          this.valorTotalReal = 0
          this.valorIngresos = 0

          this.valorIngresos = resultVenta.length === 0 ? 0 : resultVenta
          this.valorReal = this.valorTotalReal - (this.valorIngresos - this.valorEgresos)

        }

  }

buscarvaloresDiscriminados(companiasId:string,fechaCerrar:string){
  let datos = {
    usuarioCuadro:this.usuarioId,
    companiasId:companiasId,
    fechaVenta:fechaCerrar
  }

  this.servicioCuadres.buscarValorIngresoDiscriminado(datos)
  .subscribe(data=>{
    data = NUBE_AWS ? JSON.parse(data['_body']).data[0] : data
    let valor = JSON.stringify(data)
    this.valorIngresoDiscriminado = JSON.parse(valor)
  },error=> {

  })
}

async buscarVentasDiarias(){
  let companiasId = await this.storage.get('companiasId')
  let usuariosId  = await this.storage.get('usuariosId')
  this.servicioCuadres.buscarDomiciliosCierre(companiasId,usuariosId)
    .subscribe(data=>{
      data = NUBE_AWS ? JSON.parse(data['_body']).data[0] : data
      let valor = JSON.stringify(data)
      this.valorIngresosTodo = NUBE_AWS ? data : JSON.parse(valor)
    },(error)=> {
      console.log(error)
    })

}

async actualizarValores(item:any,posicion:number){
  this.usuarioId = item.usuariosId
  this.valorIngresos = item.Total
  this.posicion = posicion
  this.storage.set('usuarioQueEstaCerrando',item.usuariosId)
  let companiasId = await this.storage.get('companiasId')
  let fecha =  item.fecha
   this.servicioCuadres.buscarDomiciliosCierreDescriminado(companiasId,item.usuariosId,fecha)
   .subscribe(
     (res:any) => {
       res = NUBE_AWS ? JSON.parse(res['_body']).data[0]: res
       this.visualizarVentas = res
       this.calcularTotalVentas()
     },
     err => {

      })

}

calcularTotalVentas() {
  this.totalVentas = this.visualizarVentas.reduce((acc, item) => acc + item.Total, 0);
}

buscarValorReal(){
  this.valorReal = this.valorTotalReal - (this.valorIngresos - this.valorEgresos)
}
 buscarGridProveedores(){
  this.storage.get('companiasId').then((val) => {
    let companiaId = val
    this.storage.get('usuariosId').then((val) => {
    this.servicioStock.buscarGrid(companiaId,val)
  .subscribe((data)=>{
   data = NUBE_AWS ? JSON.parse(data['_body']).data[0] : data
   var result = 0;
   data.forEach( (val) => result += val.Valor);
    this.valorEgresos = result
  })
  this.buscarValorReal()
})
})
}

 buscarUsuario(){
  this.storage.get('usuariosId').then((usuarioIngreso) => {
    this.usuarioId = usuarioIngreso
  })
 }
 buscarcompanias(){
  this.storage.get('companiasId').then((companiasId) => {
    this.companiasId = companiasId
  })
 }

 search(cantidadafn:any,i:any){

  setTimeout(() => {

    let cantidad = cantidadafn['_value']
    let valor = this.listaDenominaciones[i]['valorDenominacion']
    let total = cantidad * valor
    this.listaDenominaciones[i]['supervalor'] = total
    this.valorTotalReal = 0
      for (var k = 0; k < this.listaDenominaciones.length; k++) {
        if(this.listaDenominaciones[k]['supervalor'] !==undefined){
          this.valorTotalReal += this.listaDenominaciones[k]['supervalor']
          if(this.listaDenominacionesSend.length == 0){
            if(this.listaDenominacionesSend.denominacionesId===undefined){
              this.listaDenominacionesSend.push({
                denominacionesId: this.listaDenominaciones[i]['denominacionesId'],
                cantidad:cantidadafn['_value'],
                id: i,
                fechaCuadre: this.devolverFechaCiere(),
                usuarioCuadro: this.usuarioId,
                companiasId: this.companiasId
              })
            }else{
              this.listaDenominacionesSend[i]['denominacionesId'] =  this.listaDenominaciones[i]['denominacionesId']
              this.listaDenominacionesSend[i]['cantidad'] = cantidadafn['_value']
              this.listaDenominacionesSend[i]['id'] = i
              this.listaDenominacionesSend[i]['fechaCuadre'] = this.devolverFechaCiere()
              this.listaDenominacionesSend[i]['usuarioCuadro'] = this.usuarioId
              this.listaDenominacionesSend[i]['companiasId'] = this.companiasId
            }
            }else{
              let exists = 0
                  let valorRealPosicion = 0
                  let valorGridAnterior = 0
                  for(let y = 0; y < this.listaDenominacionesSend.length; y++ ){
                    if(this.listaDenominacionesSend[y].id == k ){
                      exists =  100
                      valorRealPosicion = y
                      valorGridAnterior = this.listaDenominacionesSend[y].id
                      y = valorRealPosicion + 1
                    }
                  }
                  if(exists !== 100){
                    this.listaDenominacionesSend.push({
                      denominacionesId: this.listaDenominaciones[i]['denominacionesId'],
                      cantidad:cantidadafn['_value'],
                      id: k,
                      fechaCuadre: this.devolverFechaCiere(),
                      usuarioCuadro: this.usuarioId,
                      companiasId: this.companiasId
                    })
             }else{
              if(exists == 100 && valorGridAnterior == i){
               let idComparar = this.listaDenominacionesSend[valorRealPosicion]['id']
               if(idComparar === i){
                 this.listaDenominacionesSend[valorRealPosicion]['cantidad'] = cantidadafn['_value'];
               }
             }
            }
          }
        }
      }
      this.buscarValorReal()
   }, 1000);

 }
 devolverFechaVentasDiarias(): string{
  var f = new Date();
  let fechaSinFormato = f.getFullYear() + "-" + (f.getMonth() +1) + "-" + f.getDate()

  let fecha = this.formatearCadena(fechaSinFormato)
  return fecha

 }

devolverFechaCiere(): string{
  var f = new Date();
  // let fechaSinFormato = f.getFullYear() + "-" + f.getDate() + "-" + (f.getMonth() +1)
  let fechaSinFormato = f.getFullYear() + "-" +  (f.getMonth() +1) +  "-" + f.getDate()

  let fecha = this.formatearCadena(fechaSinFormato)
  return fecha

 }

 formatearCadena(cadena){
  let valorinicial = cadena.length
  let primero,segundo,ultimo
  primero = cadena.substr(0,4)
  segundo = cadena.substr(5,2)
  ultimo = cadena.substr(valorinicial - 2, valorinicial)
  if(valorinicial != 10){
    let recorrer = cadena.split('-')
    for(var i = 0; i < recorrer.length;i++) {
      if(i == 1 && recorrer[i].length == 1) {
        segundo = `0${recorrer[i]}`
      }
      if(i == 2 && recorrer[i].length == 1){
        ultimo = `0${recorrer[i]}`
      }
    }
  }
  return `${primero}-${segundo}-${ultimo}`
}


  limpiar(){
    this.arrayWhere  = [{"":""}];
    this.arrayWherelocal  = []
    this.jsoncolumnanuevo = [];
    this.datosWhere = [];
    this.valorWhere = [];
    this.nuevacondicion = [];
    this.ValoresWhereConsultaarray = [];
    this.WhereCampo = [];
    this.WhereCondicion = [];
    this.WhereValor = [];
    this.WhereCondicionFinal = [];
    this.consultar = "";
    this.productosId = undefined
    this.valorIngresos = 0
    this.valorEgresos = 0
    this.valorReal = 0
    this.listaCorreos = []
    this.valorTotalReal = 0
    this.valorEgresos = 0
    this.listaDenominacionesSend = []
    this.valorPagado = 0
    this.valorPendiente = 0
    this.valorEgreso = 0
    this.valorIngreso = 0
    this.valorPropinas = 0
    this.agregarComponente(0,0);
  }

  limpiarBoton(){
    this.valorIngresos = 0
    this.valorTotalReal = 0
    this.valorEgresos =0
    this.valorReal=0
    this.valorIngresoDiscriminado=[]
    this.buscarDenominaciones()
  }

  limpiarAdmin(){
    this.arrayWhere  = [{"":""}];
    this.arrayWherelocal  = []
    this.jsoncolumnanuevo = [];
    this.datosWhere = [];
    this.valorWhere = [];
    this.nuevacondicion = [];
    this.ValoresWhereConsultaarray = [];
    this.WhereCampo = [];
    this.WhereCondicion = [];
    this.WhereValor = [];
    this.WhereCondicionFinal = [];
    this.consultar = "";
    // this.agregarComponente(0,0);
    this.valorIngresosTodoUsuario = []
    this.listaDenominacionesSend = []
  }
  agregarComponente(costounitario:any,cantidad:any){

      if(cantidad.value==""){
        // this.mostrarMensaje('La cantidad es requerido verifique...','Advertencia')
        this.utils.mensajeMuestro('Cierre de Caja','La cantidad es requerida','warning')
        return false
      }


    this.storage.get('usuariosId').then((usuarioIngreso) => {

      var f = new Date();
      let fechaSinFormato = f.getFullYear() + "-" + (f.getMonth() +1) + "-" + f.getDate()

      let fecha = this.formatearCadena(fechaSinFormato)

      this.nuevacondicion.push({
        DenominacionesId:this.proveedorId[0].value,
        productosId:  this.productosId,
        cantidad: cantidad.value,
        fechaIngreso: fecha ,
        usuarioIngreso: usuarioIngreso,
        costoUnitario: costounitario.value,
        queHago: "I",
        name: "dataDynamicCrud",
        nombreTabla:"seguimientoIngresosStock"
      }
    )

  })

    this.nuevacondicion.push({"":""})

}
guardarCuadre(){
  this.loader = this.loaders.create({});
  this.loader.present();
  let datos:any[] = []
  let cambiarFecha:boolean = false
  let fecha = ''

  if(this.fechaCerrar!==undefined){
    fecha = this.fechaCerrar.replace("/","-")

    fecha = fecha.trim()
    cambiarFecha = true
  }
  this.storage.get('usuarioQueEstaCerrando').then((val) => {
    this.usuarioId = val

    if(this.listaDenominacionesSend!==undefined && this.valorTotalReal != 0){
      for(let y = 0; y < this.listaDenominacionesSend.length; y++ ){

        datos.push({
            "fechaCuadre": cambiarFecha ? fecha : this.listaDenominacionesSend[y].fechaCuadre,
            "usuarioCuadro": this.usuarioId, // cambiarFecha ? this.usuarioId :this.listaDenominacionesSend[y].usuarioCuadro,
            "companiasId":this.listaDenominacionesSend[y].companiasId,
            "denominacionesId":this.listaDenominacionesSend[y].denominacionesId,
            "cantidad":this.listaDenominacionesSend[y].cantidad,
            "base": this.base
          }
        )
      }

     if(!MODO_DESCONECTADO){
     let fecha =  datos[0].fechaCuadre
     let usuariosId = datos[0].usuarioCuadro
     let companiasId = datos[0].companiasId
      this.servicioCuadres.almacenarCuadreDomiciliosDiario(companiasId,usuariosId,fecha,this.valorIngresos,this.valorReal,this.base)
      .subscribe(
        res => {
          res = NUBE_AWS ? JSON.parse(res['_body']).data[0]: res
          this.buscarVentasDiarias()
          this.valorIngresos = 0
          this.valorTotalReal = 0
          this.valorEgresos =0
          this.valorReal=0
          this.valorBaseString = ''
          this.valorIngresoDiscriminado=[]
          this.buscarDenominaciones()
          this.visualizarVentas = []
          this.utils.mensajeMuestro('Cierre domicilios','Registros almacenados con éxito','success')
        // if(this.imprimirCierre) {
        //   if(this.bluetooth) {
        //     this.imprimirC(res['_body'])
        //     .subscribe((data)=>{
        //       this.descargarArchivo(data['_body'])
        //     })
        //   } else {
        //     this.imprimir(res)
        //   }
        // } else {
        //   this.utils.mensajeMuestro('Cierre domicilios','Registros almacenados con éxito','success')
        // }
        },
        err => {
          // this.mostrarMensajeDeError('No se pudo guardar el producto, intente luego')
          this.utils.mensajeMuestro('Cierre de Caja','No se pudo guardar. Intente luego','error')
        })
     }
    else{

          let cierre  = this._electronService.ipcRenderer.sendSync('guardar-cierre-mododesconectado',datos,RUTA_MODO_DESCONECTADO)

          if(cierre){

          // this.mostrarMensaje('Registros guardados con exito...','')

            let alert = this.alertControllers.create({
              title: 'Cierre',
              subTitle: 'Cierre generado con exito...',
              buttons: ['Cerrar']
          });
          this.limpiar()
          alert.present();
          let eliminar  = this._electronService.ipcRenderer.sendSync('eliminar-ventas-modo-desconectado',RUTA_MODO_DESCONECTADO)
          }
        }

    }else{
      // this.mostrarMensaje('No ha seleccionado ninguna denominación','Advertencia')
      this.utils.mensajeMuestro('Cierre de Caja','No ha seleccionado ninguna denominación','warning')
    }
  });


  this.nuevacondicion = []
  this.nuevacondicion.push({"":""})
  this.loader.dismiss()
}

imprimir(recibo:any){
          var data =  NUBE_AWS ? recibo : JSON.parse(recibo._body)
          data = NUBE_AWS ? data : data[0]
          var archivo = ''
          for (let i=0;i<data.length;i++){
            archivo = archivo + `
    ${data[i].reciboCaja} `

          }

          archivo = archivo + `

          `

          // this.enviarCorreo(recibo)
          this.servicio.imprimirRecibo(archivo).subscribe(
            res => {
              //this.enviarCorreo(recibo)
            },
            err => {
                // si hay errores y no pudo imprimir debe guardar el archivo o seleccionar otra impresora
                let alert = this.alertControllers.create({
                    title: '',
                    subTitle: recibo,
                    buttons: ['Cerrar']
                });
                alert.present();
            }
        )
}



enviarCorreo(recibo:any){
  if(this.listaCorreos.length==0){
    this.mostrarMensajeDeError('No existen correos registras para poder hacer el proceso')
  }else{

    let valor = NUBE_AWS ? recibo : JSON.parse(recibo._body)
    if(NUBE_AWS){
      return
    }
    let valorNuevo = valor[0]
    let fecha = this.devolverFechaCiere()
    let datosEnvioCorreo = []
    datosEnvioCorreo[0] = {"from":this.from};

    for(let i =0;i<this.listaCorreos.length;i++){

      datosEnvioCorreo[1] = {"to":this.listaCorreos[i].correoElectronico};
      datosEnvioCorreo[2] = {"subject":"Informe cierre ventas: " + fecha};
      datosEnvioCorreo[3] = {"text":"Contenido del correo"};
      datosEnvioCorreo[4] = {"html":"el contenido del html "};
      datosEnvioCorreo[5] = {"filename":'cuadre caja '+fecha+'.txt'};
      datosEnvioCorreo[6] = {"content":"contenido"};
      datosEnvioCorreo[7] = {"contentType":"text/plain"};
      datosEnvioCorreo[8] = {"fecha":fecha};

      this.servicioCuadres.enviarCorreo(valorNuevo,datosEnvioCorreo)
        .subscribe(
          res => {
            console.log(res)
          },
          err => {
            console.log(err)
          }
        )
    }

    }

}
guardar(){
  this.loader = this.loaders.create({});
  this.loader.present();
  this.nuevacondicion.map((value,item)=> {
    let datoscopia = {}

    datoscopia['DenominacionesId'] = value['DenominacionesId'],
    datoscopia['productosId'] = Number(value['productosId']),
    datoscopia['cantidad'] = Number(value['cantidad']),
    datoscopia['fechaIngreso'] = value['fechaIngreso'] ,
    datoscopia['usuarioIngreso'] = value['usuarioIngreso'],
    datoscopia['costoUnitario'] = Number(value['costoUnitario']),
    datoscopia['queHago'] = value['queHago'],
    datoscopia['name'] = value['name'],
    datoscopia['nombreTabla'] = value['nombreTabla']

    this.servicioCuadres.guardar(datoscopia)
    .subscribe(
      res => {

        this.mostrarMensaje('Registros guardados con exito...','')
      },
      err => {

        this.mostrarMensajeDeError('No se pudo guardar el producto, intente luego')
      }
    )
  })
  this.nuevacondicion = []
  this.nuevacondicion.push({"":""})
  this.loader.dismiss()
}

mostrarMensajeDeError(mensaje) {
  let alert = this.alertControllers.create({
    title: 'Error',
    subTitle: mensaje,
    buttons: ['Cerrar']
  });
  alert.present();
  this.loader.dismiss()
}

mostrarMensaje(mensaje,advertencia) {
  let alert = this.alertControllers.create({
    title: advertencia,
    subTitle: mensaje,
    buttons: ['Ok']
  });
  alert.present();
}


buscarDenominaciones(){
  this.storage.get('companiasId').then((val) => {
  this.servicioDenominaciones.buscarTodasLasDenominaciones(val)
  .subscribe((res)=> {
    this.listaDenominaciones = res.data[0]
  })
  })
}

buscarCorreos(){
  this.storage.get('companiasId').then((val) => {
  this.servicioDenominaciones.buscarCorreo(val)
  .subscribe((res)=> {
    this.listaCorreos = NUBE_AWS ? JSON.parse(res['_body']).data[0] : res
  })
})
}


buscarCiereTodosLosUsuarios(){
  this.storage.get('companiasId').then((val) => {
  this.servicioDenominaciones.buscarCorreo(val)
  .subscribe((res)=> {
    // this.listaCorreos = res
  })
})
}
printC(item:any,imagenes:boolean,canvas:boolean): void {

  let codigo = 0
  let queImprimo = 0

  codigo =  item.codigo
  if(codigo===undefined){
  codigo =  item.factura
  queImprimo = 1
  }


  this.storage.get('companiasId').then((companiasId)=>{
       this.servicio.imprimirFactura(codigo,companiasId)
      // this.servicio.imprimirComandaBlue(codigo,companiasId)

      .subscribe((data)=>{
      let mensajeafn = NUBE_AWS ? JSON.parse(data['_body']).data[0] : JSON.parse(data['_body'])
      // let mensajeafn = JSON.parse(data['_body'])
      let mensajes = mensajeafn[0]

      let item = mensajes


      this.modalPrintCualquieraBlu(item)
      })
  })

}

modalPrintCualquieraBlu(item:any){

  this.guardarBlu(item)
}

guardarBlu(item:any){
  this.imprimirC(item)
  .subscribe((data)=>{
    this.descargarArchivo(data['_body'])
  })
}

imprimirC(item:any) {

  let url = URL_SERVICIOS_LOCALES
  let itemArray = JSON.parse(item)
  const datos = {
    "nombre": JSON.stringify(itemArray[0])
    }
    let header = new Headers({
      'Content-Type': 'application/json',
      'authorization': 'Bearer ' + this.token
  })

  let options = new RequestOptions({
      headers: header
  })



  return this.http.post(`${url}/blue`,datos,options)
  .map((data) => data)

}

descargarArchivo(data:any){

  let item = data

 let modal = this.modalControllers.create(ImpresoraBluePage,{item})
  modal.present();

  modal.onDidDismiss(data => {
    if (data) {
      data.name = ""
      }
  })

}

buscarCuentaPorCobrarValorTotal(val:any, fecha: any){
  this.servicio.buscarCuentaPorCobrarValorTotalPorFecha(val,fecha)
  .subscribe(
    rest => {
      let res = JSON.parse(rest['_body'])
      this.valorPagado = res[0].valorPagado
      this.valorPendiente = res[0].valorPendiente
    },
    error => {
      console.log(error)
    })
}

buscarEgresosIngresosValorTotal(val:any, fecha: any,usuarioId: any){
  this.servicio.buscarEgresosIngresosValorTotal(val,fecha, usuarioId)
  .subscribe(
    rest => {
      let res = JSON.parse(rest['_body'])
      this.valorEgreso = res.data[0].length > 0 && res.data[0][0].tipo === 'EGRESOS' ? res.data[0][0].valor : 0;
      this.valorIngreso = res.data[0].length > 1 && res.data[0][1].tipo === 'INGRESOS' ? res.data[0][1].valor : 0;
      if(this.valorEgreso === 0 && res.data[0].length > 0 && res.data[0][0].tipo === 'INGRESOS') {
        this.valorIngreso = res.data[0][0].valor
      }
    },
    error => {
      console.log(error)
    })
}


buscarPropinasValorTotal(fecha: any,val:any){
  this.servicio.buscarPropinas(fecha,val)
  .subscribe(
    rest => {
      let res = JSON.parse(rest['_body'])
      this.valorPropinas = res.data[0].length > 0 && res.data[0][0] !== undefined && res.data[0][0].valor !== undefined ? res.data[0][0].valor : 0;
    },
    error => {
      console.log(error)
    })
}

searchSimple(cantidadNueva:any){
  setTimeout(async () => {
    let cantidadafnSimpleConvert: any = cantidadNueva !== undefined && cantidadNueva.value !== undefined ? cantidadNueva.value : ''
    const valorSinComas = cantidadafnSimpleConvert.replace(/,/g, '');

    // Convertir la cadena a un número
    let cantidadafnSimple = parseInt(valorSinComas, 10);
    if(Number(cantidadafnSimple)==0 || isNaN(cantidadafnSimple) ){
     return
   }

   let cantidadInput = cantidadafnSimple;

    if (isNaN(cantidadInput)) {
      cantidadInput = 0;
      cantidadafnSimple = 0;
      return
    }

   let cantidad = Number(cantidadafnSimple)
   this.base = cantidad
   return

 },1000)
 }


 DECIMAL_SEPARATOR  = '.'
 GROUP_SEPARATOR = ','

 format(valString) {
   if (!valString) {
       this.base = 0
       return '';
   }
   let val = valString.toString();
   try {
       this.base = Number(val.replace(/,/g, ''))
   } catch (e) {
       this.base = 0
   }

   const parts = this.unFormat(val).split(this.DECIMAL_SEPARATOR);
   return parts[0].replace(/\B(?=(?:\d{3})+(?!\d))/g, this.GROUP_SEPARATOR) + (!parts[1] ? '' : this.DECIMAL_SEPARATOR + parts[1]);
};

unFormat(val) {
   if (!val) {
       return '';
   }
   val = val.replace(/^0+/, '');

   if (this.GROUP_SEPARATOR === ',') {
       return val.replace(/,/g, '');
   } else {
       return val.replace(/\./g, '');
   }
};

dismiss(){
  this.cerrarSession()
}
cerrarSession(){
  this.auth.logout()
  this.navCtrl.setRoot('LoginPage');
}
formatFecha(fecha: string) {
  const date = new Date(fecha);
  return date.toISOString().split('T')[0];
}

descargarExcel() {
  if(this.visualizarVentas.length>0) {
    this.servicioDescargar.exportToExcel(this.visualizarVentas, 'ventas-domicilios')
  }
}

}



// WEBPACK FOOTER //
// ./src/pages/cuadre-caja-diario-domicilios/cuadre-caja-diario-domicilios.ts